import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';

interface PartDetailsNCFilePerformanceUtilizationProps {}

const PartDetailsNCFilePerformanceUtilization: FC<PartDetailsNCFilePerformanceUtilizationProps> = () => {
  return (
    <DetailsPageWrapper title="Part">
      <Text>PartDetailsNCFilePerformanceUtilization</Text>
    </DetailsPageWrapper>
  );
};

export { PartDetailsNCFilePerformanceUtilization };
